import React, {useEffect, useState} from 'react';
import MapComponent from "components/map/MapComponent";
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import queryString from "query-string";
import {LinearProgress} from "@material-ui/core";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {useHistory} from "react-router-dom";
import LeafletMapComponent from "components/map/LeafletMapComponent";

export const DELIVER_STATUS = {
    WAITING: "0",
    IN_PATH: "1",
    ARRIVED: "2",
    CANCEL: "3",
    FINAL: "4"
}

export default function DriverLocation(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [key, setKey] = React.useState(1)
    const [locationLog, setLocationLog] = useState(null)
    const [showLoading, setShowLoading] = useState(false)
    const [showDialog, setShowDialog] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")

    function requestPeykLocation() {
        let params = new FormData()
        params.append("order_id", urlParams.id)
        callApi(Urls.getPeykLocation, params, (data) => {
            if (data.location_log) {
                if (data.location_log.status !== DELIVER_STATUS.IN_PATH ||
                    data.location_log.status !== DELIVER_STATUS.ARRIVED) {
                    setLocationLog(data.location_log)
                } else if (data.location_log.status === DELIVER_STATUS.FINAL) {
                    setDialogTitle(messages.finishOrder)
                    setDialogMessage(messages.finishOrderMessage)
                    setShowDialog(true)
                    setLocationLog(undefined)
                } else if (data.location_log.status === DELIVER_STATUS.CANCEL) {
                    setDialogTitle(messages.driverStatusChanged)
                    setDialogMessage(messages.driverStatusChangedMessage)
                    setShowDialog(true)
                    setLocationLog(undefined)
                }
            }
            setKey(Math.random() * 1000)
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            setShowLoading(true)
        }, () => {
            setShowLoading(false)
        })
    }

    const timer = () => {
        if (urlParams && !locationLog) {
            requestPeykLocation()
        }
    }

    useEffect(() => {
        timer()
        const id = setInterval(timer, 60000)
        return () => clearInterval(id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div style={{height: "45em", position: "relative"}}>
        {showLoading &&
        <LinearProgress color={"secondary"}/>
        }
        {locationLog &&
        <LeafletMapComponent
            key={key}
            isFirstLode={true}
            markers={[
                {
                    latitude: locationLog ? parseFloat(locationLog.latitude) : 0,
                    longitude: locationLog ? parseFloat(locationLog.longitude) : 0,
                    icon: "https://sarfe.bpc.ir/image/catalog/Standard%20Banner/bike.png",
                    popupTitle: messages.driverLocation
                }, {
                    latitude: locationLog ? parseFloat(locationLog.customer_latitude) : 0,
                    longitude: locationLog ? parseFloat(locationLog.customer_longitude) : 0,
                    icon: "https://sarfe.bpc.ir/image/catalog/Standard%20Banner/home.png",
                    popupTitle: messages.yourLocation
                }
            ]}
        />
        }

        <DialogMessage
            showStatus={showDialog}
            title={dialogTitle}
            message={dialogMessage}
            submitTitle={messages.returnToMainPage}
            onSubmitClicked={() => {
                setShowDialog(false)
                setDialogTitle("")
                setDialogMessage("")
                props.onNavigate(history, "/")
            }}
        />
    </div>)
}